(() => {
  const initialize = () => {
    const cards = [...document.querySelectorAll('product-block[data-sussi-deferred-card-url]')];
    if (!cards.length) return;

  const hydrateCard = async (card) => {
    if (card.dataset.sussiMediaState) return;
    card.dataset.sussiMediaState = 'loading';

    try {
      const endpoint = new URL(card.dataset.sussiDeferredCardUrl, window.location.origin);
      endpoint.searchParams.set('section_id', 'sussi-product-card-full');
      const response = await fetch(endpoint, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Product card request failed: ${response.status}`);

      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fullCard = documentFragment.querySelector('[data-sussi-product-card-full] > product-block');
      if (!fullCard) throw new Error('Full product card payload is incomplete');
      card.replaceWith(fullCard);
    } catch (error) {
      delete card.dataset.sussiMediaState;
      console.warn('[SUSSILAND] Deferred product card could not be loaded.', error);
    }
  };

  const start = () => {
    if (!('IntersectionObserver' in window)) {
      cards.forEach(hydrateCard);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        hydrateCard(entry.target);
      });
    }, { rootMargin: '1200px 0px' });

    cards.forEach((card) => observer.observe(card));
  };

    ['pointerover', 'pointerdown', 'touchstart', 'keydown', 'wheel'].forEach((eventName) => {
      window.addEventListener(eventName, start, { once: true, passive: true, capture: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
